import type { RouteRecordRaw } from 'vue-router'
import { useAuth } from '@/modules/Auth/useAuth'

const meta = {
  requiresAuth: true,
  requiresAbility: 'view_annotation_report',
}

const reportsRoute: RouteRecordRaw = {
  path: '/reports',
  name: 'Reports',
  component: () => import('@/modules/Reports/RouteReports.vue'),
  beforeEnter: (to, from, next): void => {
    const { isAuthorized } = useAuth()

    // If accessing the root reports route, redirect to appropriate tab
    if (to.path === '/reports') {
      const defaultRoute = isAuthorized('view_full_datasets')
        ? '/reports/datasets'
        : '/reports/users'

      return next(defaultRoute)
    }

    next()
  },
  children: [
    {
      path: 'datasets',
      name: 'DatasetsReport',
      component: () => import('@/modules/Reports/DatasetsLayout.vue'),
      meta: {
        requiresAuth: true,
        requiresAbility: 'view_full_datasets',
      },
      beforeEnter: (to, from, next): void => {
        const { isAuthorized } = useAuth()

        if (!isAuthorized('view_full_datasets')) {
          return next('/reports/users')
        }

        next()
      },
    },
    {
      path: 'users',
      name: 'AnnotatorsReport',
      component: () => import('@/modules/Reports/AnnotatorsLayout.vue'),
      meta,
    },
  ],
  meta,
}

export default reportsRoute
